import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { IndexablePage } from "../../../components/types/types";

const normalizePath = (path: string) => {
  const clean = path.trim();

  if (clean === "") return "/";
  if (clean === "/") return "/";

  return clean.startsWith("/") ? clean : `/${clean}`;
};
export function useHomeSeo(indexablePages: IndexablePage[]) {
  const location = useLocation();

  return useMemo(() => {
    const currentPath = normalizePath(location.pathname);

    return (
      indexablePages.find(
        (page) => normalizePath(page.slug_path || "") === currentPath
      ) ?? null
    );
  }, [location.pathname, indexablePages]);
}